import {APIPagination} from "../tools/pagination/APIPagination";
import {Criterion} from "../tools/model/pagination/Criterion";

export class ClientAPIPagination extends APIPagination {
    static GRANT_TYPE_FILTER = "grantType";

    public grantType?: string

    /**
     * setCriterion
     * @param criterion
     * @returns {undefined}
     */
    public setCriterion(criterion: Criterion<any>): void {
        switch (criterion.relatedFilterKey) {
            case ClientAPIPagination.GRANT_TYPE_FILTER:
                if (criterion.value === "all") this.grantType = undefined;
                else this.grantType = criterion.value.toUpperCase()
                break;
        }

        super.setCriterion(criterion);
    }
}